import { useLocation } from 'react-router-dom'
import { RichText } from 'prismic-reactjs'
import datastore from '../datastore'
import { linkResolver } from '../prismic-configuration'
import { Crawler } from 'es6-crawler-detect'

// Récupération du cookie.
export const getCookie = (name) => {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}

// Set du cookie
export const setCookie = (name, value, days = [365]) => {
  const d = new Date()
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
}

// Set du cookie
export const deleteCookie = (name) => { setCookie(name, '', -1) }

const CrawlerDetector = new Crawler()
const isBot = CrawlerDetector.isCrawler(navigator.userAgent)

// Vérification de la langue par défault du navigateur et paramétrage en fonction
export const redirectToUserLang = (lang, page, search) => {
  let userLang = getUserLang()
  let browserLang = navigator.language.toLowerCase()

  // Check if browser language is set with no region like just 'fr' or 'en'
  if (browserLang.indexOf('-') < 0) {
    const browserLangWithRegion = datastore.apiDoc.languages.map(_ => _.id).find(_ => _.split('-')[0] === browserLang)
    browserLang = browserLangWithRegion || 'en-us'
  }

  // "userLang = 'default'" is when user set en-us lang
  if (userLang === 'default') userLang = 'en-us'

  // Check only if user is on canonical
  if (!isBot && !lang) {
    let langToRedirect = null
    // Test if no language set by user, so automatic mode, and if page lang corresponding to browser lang
    if (userLang === null && page.lang !== browserLang) {
      langToRedirect = browserLang
    // or if language is set by user but current page lang not corresponding to user lang
    } else if (userLang && page.lang !== userLang) {
      langToRedirect = userLang
    }
    // Check if this page is available in the lang requested
    if (langToRedirect && datastore.layoutDoc.alternate_languages.find(_ => _.lang === langToRedirect) && page.alternate_languages.find(_ => _.lang === langToRedirect)) {
      const al = page.alternate_languages.find(_ => _.lang === langToRedirect)
      return linkResolver(al) + search
    }
  }

  return null
}

export const getUserLang = () => {
  return getCookie('nf_lang')
}

export const setUserLang = (lang) => {
  setCookie('nf_lang', lang.toLowerCase())
}

export const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export const getPathWithCurrentLang = (lang, path) => {
  return (lang ? '/' + lang : '') + path
}

export const createRegexLang = () => /^\/([a-z]{2}-[^/]{2,})(\/|$)/g

export const getLang = (path) => {
  const matchLang = createRegexLang().exec(path)
  return matchLang ? matchLang[1] : null
}

// Mise en place du système de partage via les Réseaux Sociaux
export const socialShares = {
  twitter: (link = '', message = '') =>
      `https://twitter.com/intent/tweet/?text=${encodeURIComponent(
        message
      )}&url=${encodeURIComponent(link)}`,
  facebook: (link = '') =>
      `https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
  google: (link = '') =>
      `https://plus.google.com/share?url=${encodeURIComponent(link)}`,
  tumblr: (link = '') =>
      `http://tumblr.com/widgets/share/tool?canonicalUrl=${encodeURIComponent(
        link
      )}`,
  reddit: (link = '') =>
      `https://reddit.com/submit/?url=${encodeURIComponent(link)}`,
  whatsapp: (link = '', message = '') =>
      `whatsapp://send?text=${encodeURIComponent(message)}%20${encodeURIComponent(
        link
      )}`,
  telegram: (link = '', message = '') =>
      `https://telegram.me/share/url?text=${encodeURIComponent(
        message
      )}&url=${encodeURIComponent(link)}`,
  vk: (link = '', message = '') =>
      `http://vk.com/share.php?title=${encodeURIComponent(
        message
      )}&url=${encodeURIComponent(link)}`,
  hacker: (link = '', message = '') =>
      `https://news.ycombinator.com/submitlink?u=${encodeURIComponent(
        link
      )}&t=${encodeURIComponent(message)}`,
  xing: (link = '', message = '') =>
      `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(
        link
      )};title=${encodeURIComponent(message)}.`,
  mail: (link = '', subject, body) =>
      `mailto:?subject=${encodeURIComponent(
        subject || ''
      )}&body=${encodeURIComponent((body && `${body}\n\n${link}`) || link)}`,
  pinterest: (link = '', message = '') =>
      `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
        link
      )}&media=${encodeURIComponent(link)}&description=${encodeURIComponent(
        message
      )}`,
  linkedin: (link = '', message = '') =>
      `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
        link
      )}&title=${encodeURIComponent(message)}&summary=${encodeURIComponent(
        message
      )}&source=${encodeURIComponent(link)}`
}

export const trackCurrentPage = () => {
  window.gtag && window.gtag('config', window.GA_MEASUREMENT_ID, { page_path: window.location.pathname })
}

export const getApplyJobOfferLabel = () => {
  return datastore.layoutDoc.data.job_offer[0].cta_apply_label
}

export const getTypeFormUrlWithParams = (url) => {
  const query = new URLSearchParams()
  const queryParameters = new URLSearchParams(window.location.search)
  const urltest = new URL(url);
  const newurl = url.replaceAll(urltest.origin, "").replaceAll(urltest.pathname, "");
  let testparam = false
  if (newurl[0] === "?" || newurl[0] === "#")
  {
    testparam = true
  }
  // const filiale = queryParameters.get('filiale')
  const utmCampaign = queryParameters.get('utm_campaign')
  const utmMedium = queryParameters.get('utm_medium')
  const utmContent = queryParameters.get('utm_content')
  const utmSource = queryParameters.get('utm_source')
  const utmTerm = queryParameters.get('utm_term')
  /*
  if (filiale != null)
  {
    query.set('filiale', filiale)
  }
  */  
  if (utmCampaign != null)
  {
    query.set('utm_campaign', utmCampaign)
  }
  if (utmMedium != null)
  {
    query.set('utm_medium', utmMedium)
  }
  if (utmContent != null)
  {
    query.set('utm_content', utmContent)
  }
  if (utmSource != null)
  {
    query.set('utm_source', utmSource)
  }
  if (utmTerm != null)
  {
    query.set('utm_term', utmTerm)
  }
  query.set('source', datastore.ref || '')
  if (testparam)
  {
    return url + '&' + query.toString()
  }
  else
  {
    return url + '?' + query.toString()
  }
}

export const getTypeFormUrlApplyJobOffer = (jobOffer) => {
  const query = new URLSearchParams()
  const queryParameters = new URLSearchParams(window.location.search)
  // const filiale = queryParameters.get('filiale')
  const utmCampaign = queryParameters.get('utm_campaign')
  const utmMedium = queryParameters.get('utm_medium')
  const utmContent = queryParameters.get('utm_content')
  const utmSource = queryParameters.get('utm_source')
  const newsource = queryParameters.get('source')
  const utmTerm = queryParameters.get('utm_term')
  /*
  if (filiale != null)
  {
    query.set('filiale', filiale)
  }
  */  
  if (utmCampaign != null)
  {
    query.set('utm_campaign', utmCampaign)
  }
  if (utmMedium != null)
  {
    query.set('utm_medium', utmMedium)
  }
  if (utmContent != null)
  {
    query.set('utm_content', utmContent)
  }
  if (utmSource != null)
  {
    query.set('utm_source', utmSource)
  }
  if (utmTerm != null)
  {
    query.set('utm_term', utmTerm)
  }
  if (newsource != null)
  {
    query.set('source', newsource)  
  }
  else
  {
    query.set('source', datastore.ref || '')
  }
  query.set('offre_id', jobOffer.uid)
  query.set('offre_lib', RichText.asText(jobOffer.data.title))
  query.set('email_recruteur', jobOffer.data.recruiter_email || '')
  const subsidiary = jobOffer.data.subsidiary_page.id || null
  if (subsidiary != null) {
    const subsidiarypage = datastore.allsubsidiarypages.find(_ => _.id === subsidiary)
    if (subsidiarypage) {
      query.set('filiale', subsidiarypage.data.name || jobOffer.data.subsidiary || '')
    }
    else {
      query.set('filiale', jobOffer.data.subsidiary || '')
    }
  }
  else {
    query.set('filiale', jobOffer.data.subsidiary || '')
  }
  query.set('secteur', jobOffer.data.sector.uid || '')
  return datastore.layoutDoc.data.job_offer[0].cta_apply_link.url + '?' + query.toString()
}

export const openTypeFormPopup = (url) => {
  window.typeformEmbed.makePopup(url, {
    mode: 'popup',
    autoOpen: true
  })
}
